import { isDemoLocked } from "./demoConfig";

export const DEMO_URL_SHARING_NOTICE =
  "Links created in this demo preview are stored in your current browser session only. Copied URLs will not work when opened in another browser, device, or shared externally.";

export const shouldShowDemoUrlSharingNotice = () => isDemoLocked();
